/**
 * Frontend Order System - Main Entry Point
 * 
 * This file initializes the React application and renders it into WordPress
 */

import { render } from '@wordpress/element';
import FrontendOrderApp from './components/FrontendOrderApp';

// Initialize the application when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Find all frontend order system containers
    const containers = document.querySelectorAll('.frontend-order-system-container');
    
    containers.forEach(container => {
        // Get configuration from data attributes
        const productId = container.getAttribute('data-product-id');
        const isShortcode = container.getAttribute('data-is-shortcode') === 'true';
        
        // Get localization data from global variable
        const localization = window.frontendOrderSystemLocalization || {};
        
        // Validate required data
        if (!productId) {
            container.innerHTML = '<div class="fos-error">⚠️ 產品ID缺失</div>';
            return;
        }
        
        if (!localization.apiUrl || !localization.nonce) {
            container.innerHTML = '<div class="fos-error">⚠️ 系統配置錯誤</div>';
            return;
        }
        
        // Render the React application
        render(
            <FrontendOrderApp 
                productId={parseInt(productId)}
                isShortcode={isShortcode}
                localization={localization}
            />,
            container
        );
    });
});

// Export for potential external usage
window.FrontendOrderSystem = {
    render: (container, props) => {
        render(<FrontendOrderApp {...props} />, container);
    }
};